module.exports = __webpack_public_path__ + "static/thatLogo-c62dfaf228c810420e7ebb975ecf21a3.svg";